import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ResidentPortalConfig } from './resident-portal.config';
import { ResidentPortalComponent } from './resident-portal.component';
import { StepPageModule } from '../../common/directives';

export const ResidentPortalStepModule = angular
  .module('app.steps.resident-portal', [uiRouter, StepPageModule.name])
  .config(ResidentPortalConfig)
  .component('updResidentPortal', ResidentPortalComponent);
